import { IActionContext } from '@msdyn365-commerce/core';
import { IPredefinedRefinerHandler } from '../predefined-refiners';
import { getHandler as getConceptHandler } from './concept';
import { getHandler as getHkjottAgreementHandler } from './hkjott-agreement';
import { getHandler as getForsvaretAgreementHandler } from './forsvaret-agreement';

export default function getHandlers(context: IActionContext): IPredefinedRefinerHandler[] {
    return [
        getConceptHandler(context),
        getHkjottAgreementHandler(context),
        getForsvaretAgreementHandler(context)
    ].filter(Boolean) as IPredefinedRefinerHandler[];
}
